import { render } from "./QuienesSomos.vue?vue&type=template&id=8a738cbc&scoped=true"
const script = {}

import "./QuienesSomos.vue?vue&type=style&index=0&id=8a738cbc&scoped=true&lang=css"

import exportComponent from "/home/hans/Proyectos/Clever/AlicaMedios/alicamedios.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a738cbc"]])

export default __exports__